module.exports = __webpack_public_path__ + "images/dummyprofile.4c1298f8.webp";